<template>
    <div :class="{ moderate: options.moderate }" class="card-notification">
        <div class="header">
            <div class="icon">
                <div :class="{ show: !read }" class="new"></div>
                <Avatar :icon="value.eventType" class="avatar" />
            </div>

            <div class="text">
                <router-link v-if="value.productId"
                             :to="{ name: 'product', params: { id: value.productId } }"
                             class="title"
                             @click.native="close">
                    {{ title }}
                </router-link>
                <div v-else class="title">{{ title }}</div>
                <div class="date">{{ value.created | dateFormat }}</div>
            </div>

            <router-link v-if="value.productId && !options.moderate"
                         :to="{ name: 'product', params: { id: value.productId } }"
                         class="link iconed"
                         @click.native="close">
                <span class="text">Перейти</span>
                <IconChevronRight class="icon" />
            </router-link>
        </div>
        <div class="info">
            <span v-show="options.initiatorBeforeText" class="user-before">{{ initiatorName }} </span>
            <span :class="{ after: options.initiatorBeforeText }" class="description" v-html="description"></span>

            <div v-show="message" class="comment">
                <div class="title">Комментарий:</div>
                <div class="text">{{ message }}</div>
            </div>

            <div v-show="options.initiatorAfterText" class="user-after">{{ initiatorName }}</div>

            <router-link v-if="value.productId && options.moderate"
                         :to="{ name: 'product', params: { id: value.productId } }"
                         @click.native="close"
                         class="link primary"
                         tag="button">
                <span class="text">Перейти</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import dateFormat from '@dsee/components/filters/dateFormat.js';
import Timer from '@dsee/util/timer.js';
import Avatar from './common/Avatar.vue';
import IconChevronRight from './icons/chevron_right.svg?component';

const options_card = {
    PRODUCT_CREATED: {
        moderate: true,
        initiatorBeforeText: true,
        text: 'запрашивает разрешение на публикацию карточки',
        initiatorAfterText: false,
    },
    DRAFT_CREATED: {
        moderate: true,
        initiatorBeforeText: true,
        text: 'запрашивает разрешение на публикацию внесенных  изменений в карточку',
        initiatorAfterText: false,
    },
    PRODUCT_PUBLISHED: {
        moderate: false,
        initiatorBeforeText: true,
        text: 'опубликовал(a) карточку',
        initiatorAfterText: false,
    },
    DRAFT_PUBLISHED: {
        moderate: false,
        initiatorBeforeText: true,
        text: 'внес(ла) изменения в карточку',
        initiatorAfterText: false,
    },
    PRODUCT_UNARCHIVED: {
        moderate: false,
        initiatorBeforeText: true,
        text: 'заново опубликовал(а) карточку',
        initiatorAfterText: false,
    },
    DRAFT_DELETED: {
        moderate: false,
        initiatorBeforeText: true,
        text: `отменил(а) публикацию изменений`,
        initiatorAfterText: false,
    },
    MESSAGE: {
        moderate: false,
        initiatorBeforeText: true,
        text: 'отправил(а) вам сообщение',
        initiatorAfterText: false,
    },
    RATED: {
        moderate: false,
        initiatorBeforeText: false,
        text: 'Пользователь оценил карточку',
        initiatorAfterText: true,
    },
    TAG_ADDED: {
        moderate: false,
        title: 'Создан новый тег',
        initiatorBeforeText: true,
        text: '',
        initiatorAfterText: false,
    },
    TAG_ALIAS_ADDED: {
        moderate: false,
        title: 'Добавлен синоним',
        initiatorBeforeText: true,
        text: '',
        initiatorAfterText: false,
    },
};

export default {
    name: 'CardNotification',
    components: {
        Avatar,
        IconChevronRight,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            read: false,
        };
    },
    computed: {
        options() {
            return options_card[this.value.eventType];
        },
        description() {
            if (this.value.extra) {
                if (this.value.eventType === 'TAG_ADDED')
                    return `создал(а) новый тег <a href="/admin?tab=dict_tag&id=${ this.value.extra.id }">${
                        this.value.extra.name }</a>`;

                if (this.value.eventType === 'TAG_ALIAS_ADDED')
                    return `добавил(а) синоним к тегу <a href="/admin?tab=dict_tag&id=${ this.value.extra.id }">${
                        this.value.extra.name }</a>`;
            }

            return this.options.text;
        },
        message() {
            return this.value.message;
        },
        initiatorName() {
            return this.value.initiatorName;
        },
        title() {
            if (this.value.productId)
                return this.value.productName;

            return this.options.title ?? 'Новое уведомление';
        },
    },
    filters: {
        dateFormat(dateCard) {
            const today = new Date();
            let yesterday = new Date();
            yesterday = yesterday.setDate(today.getDate() - 1);
            const currentDate = dateFormat(dateCard, 'rus.date');

            switch (currentDate) {
                case dateFormat(today, 'rus.date'):
                    return 'Сегодня';
                case dateFormat(yesterday, 'rus.date'):
                    return 'Вчера';
                default:
                    return currentDate;
            }
        },
    },
    created() {
        this.read = this.value.viewed;
    },
    mounted() {
        const options = {
            root: this.$parent.$parent.$el,
            rootMargin: '0px',
            threshold: 0.2,
        };

        const observer = this.$options.observer = new IntersectionObserver(this.onRead, options);
        observer.observe(this.$el);
    },
    destroyed() {
        this.$options.observer.disconnect();
    },
    methods: {
        onRead([ entry ]) {
            if (entry.isIntersecting && !this.read) {
                this.$emit('read', this.value.id);

                const timer = new Timer();
                timer.setTimeout(() => {
                    this.read = true;
                }, 10000);
            }
        },
        close() {
            this.$emit('closeModal');
        },
    },
};
</script>

<style lang="scss" scoped>
.card-notification {
    padding: 24px 32px 20px;
    margin-top: 16px;
    position: relative;
    box-sizing: border-box;

    @media (max-device-width: 767px) {
        padding: 20px 32px 20px 16px;
    }

    &:before {
        content: '';
        height: 1px;
        max-width: 454px;
        width: 100%;
        background-color: rgba(16, 24, 40, 0.1);
        position: absolute;
        top: -16px;
    }

    &:hover {
        background: rgba(243, 243, 253, 0.5);

        .header > .link {
            visibility: inherit;
        }
    }

    .header {
        display: flex;
        margin-left: 8px;
        margin-bottom: 16px;

        .icon {
            display: inline-flex;
            align-items: center;
        }

        .new {
            margin-left: -8px;
            width: 5px;
            height: 5px;
            background-color: #FF0000;
            border-radius: 50%;

            &:not(.show) {
                visibility: hidden;
            }
        }

        .avatar {
            margin-left: 8px;
        }

        .text {
            margin-left: 12px;
            flex: auto;
        }

        .title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #101828;
            font-weight: 500;
            letter-spacing: 0.03em;
        }

        .date {
            color: rgba(16, 24, 40, 0.6);
            font-size: 12px;
            line-height: 16px;
        }

        .link {
            align-items: center;
            visibility: hidden;
            font-weight: 500;
            font-size: 14px;
        }
    }

    .info {
        margin-left: 55px;

        .user-after {
            color: rgba(16, 24, 40, 0.6);
            margin-top: 8px;
        }

        .comment {
            margin-top: 15px;
            font-size: 12px;
            line-height: 16px;
            color: rgba(16, 24, 40, 0.6);
            margin-bottom: 4px;

            .text {
                padding: 12px;
                background: rgba(16, 24, 40, 0.03);
                border-radius: 8px;
            }
        }
    }

    &.moderate {
        &:before {
            height: 1px;
            max-width: 454px;
            width: 100%;
            background-color: rgba(16, 24, 40, 0.1);
            position: absolute;
            top: -16px;
        }

        .user-before {
            color: var(--text-color);
            display: block;
        }

        .description {
            color: rgba(16, 24, 40, 0.6);
        }

        .link {
            margin-top: 16px;
            display: block;
            padding: 4px 12px;
            font-size: 12px;
            line-height: 16px;
        }
    }
}
</style>
